import React from "react";
import { Trans } from "react-i18next";
import { FileInput, Callout, Spinner } from "@blueprintjs/core";
import i18n from "../../i18n";
import {
  authenticatedGetFetchBlob,
  authenticatedPostFile,
} from "../../utils/AuthenticatedFetch";

export class LogoSelector extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedLogo: undefined,
      tooBig: false,
      notImg: false,
      uploading: false,
      lastSend: "",
      logo: null,
    };
  }

  update() {
    authenticatedGetFetchBlob("/settings/logo", async (img) => {
      this.setState({ logo: img, lastSend: new Date() });
    });
  }

  componentDidMount() {
    this.update();
  }

  render() {
    return (
      <Callout title={i18n.t("Logo client")} icon="media">
        <FileInput
          buttonText={i18n.t("browse")}
          text={i18n.t("select a logo")}
          onChange={(event) => {
            console.info(event.target.files[0].type);

            this.setState(
              {
                tooBig: event.target.files[0].size > 300000,
                notImg:
                  event.target.files[0].type !== "image/png" &&
                  event.target.files[0].type !== "image/jpg" &&
                  event.target.files[0].type !== "image/jpeg" &&
                  event.target.files[0].type !== "image/gif" &&
                  event.target.files[0].type !== "image/webp" &&
                  event.target.files[0].type !== "image/svg+xml",
                uploading: false,
              },
              () => {
                if (!this.state.tooBig && !this.state.notImg) {
                  this.setState(
                    {
                      selectedLogo: event.target.files[0],
                      uploading: true,
                    },
                    () => {
                      authenticatedPostFile(
                        "/settings/logo",
                        this.state.selectedLogo,
                        () =>
                          this.setState(
                            { uploading: false, lastSend: new Date() },
                            () => this.update()
                          )
                      );
                    }
                  );
                }
              }
            );
          }}
        />
        <br />
        <img
          style={{ maxHeight: 300 }}
          src={this.state.logo}
          alt={"your logo" + this.state.lastSend}
        />
        {this.state.tooBig ? (
          <Callout intent="danger">
            <Trans>file is too big</Trans>
          </Callout>
        ) : null}
        {this.state.notImg ? (
          <Callout intent="danger">
            <Trans>bad image format</Trans>
          </Callout>
        ) : null}
        {this.state.uploading ? <Spinner /> : null}
      </Callout>
    );
  }
}
